import * as api from '../api/tags';

// Actions Creators

// Actions Creator
export const getTags = () => async (dispatch) => {

    try {
        const { data } = await api.fetchTags();

        dispatch({ type: 'FETCH_ALL_TAG', payload: data });

    } catch (error) {
        console.log(error)
    }
} 

export const getSelectedTag = (tag) => async (dispatch) => {
    try {
        dispatch({ type: 'SELECTED_TAG', payload: tag });

    } catch (error) {
        console.log(error)
    }
} 
    
export const createTags = (tag) => async (dispatch) => {

    try {
        const { data } = await api.createTags(tag);
        console.log(data)

        dispatch({ type: 'CREATE_TAG', payload: data });

    } catch (error) {
        console.log(error)
    }
}

export const updateTag = (id, tag) => async (dispatch) => {
    try {
        const { data } = await api.updateTag(id, tag);

        dispatch({ type: 'UPDATE_TAG', payload: data });

    } catch (error) {
        console.log(error)
    }
}

export const deleteTag = (id) => async (dispatch) => {
    try {
        await api.deleteTag(id);

        dispatch({ type: 'DELETE_TAG', payload: id });

    } catch (error) {
        console.log(error)
    }
}
